import { useUtilityContext } from '@Context/prompt-toolbox/UtilityContext';
import { FolderPlus, Sidebar, XCircle } from '@phosphor-icons/react';
import React, { useEffect } from 'react';
import LibraryList from './LibraryList';
import { usePromptToolboxContext } from '@Context/prompt-toolbox/PromptToolboxContext';
import { BounceLoader } from 'react-spinners';
import colors from '@Common/assets/colors';

interface Props {
  toggled: boolean;
  onToggleSidebar: () => void;
}

const ImportLibraryView: React.FC<Props> = ({ toggled, onToggleSidebar }) => {
  const { loaders, setView } = useUtilityContext();
  const {
    libraryPrompts,
    selectedLibrary,
    importLibrary,
    fetchLibraryPrompts,
  } = usePromptToolboxContext();

  useEffect(() => {
    fetchLibraryPrompts();
  }, []);

  const handleImport = async () => {
    if (selectedLibrary.length > 0) {
      await importLibrary();
    } else {
      console.log('Select library prompt to import');
      //error msg
    }
  };

  return (
    <>
      <div
        className={`flex flex-row items-center gap-x-4 transition-all duration-300 ease-in-out ${toggled ? 'md:rounded-tr-2xl' : 'md:rounded-t-2xl'} bg-primary-700 px-6 py-4`}
      >
        <button onClick={onToggleSidebar}>
          <Sidebar size={25} weight="fill" className="text-white" />
        </button>
        <div className="flex w-full flex-row items-center justify-between">
          <span className="font-inter text-xs font-semibold tracking-widest text-white md:text-base">
            IMPORT FROM LIBRARY
          </span>
          <div className="flex flex-col gap-x-2 gap-y-2 text-sm md:flex-row">
            {loaders.importPrompt || loaders.commentLibrary ? (
              <div className="flex flex-row items-center gap-x-2">
                <label className="animate-pulse text-sm tracking-wide text-white">
                  {loaders.importPrompt
                    ? 'Importing Prompt/s'
                    : 'Uploading Comment'}
                </label>
                <BounceLoader size={28} color={colors.brandWarning[300]} />
              </div>
            ) : (
              <>
                <button data-testid="import-button"
                  // disabled={disable}
                  onClick={handleImport}
                  className="flex flex-row items-center gap-x-1 rounded-md bg-primary-200 px-3 py-1 disabled:bg-gray-500"
                >
                  <FolderPlus size={20} />
                  <label className="cursor-pointer">{`Import (${selectedLibrary.length})`}</label>
                </button>
                <button
                  // disabled={disable}
                  className="flex flex-row items-center gap-x-1 rounded-md bg-brandRed-300 px-3 py-1 text-white disabled:bg-gray-500"
                  onClick={() => setView('Diff')}
                >
                  <XCircle size={20} />
                  <label className="cursor-pointer">Cancel</label>
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className={`flex h-full w-full flex-row gap-x-2 overflow-hidden transition-all duration-300 ease-in-out ${toggled ? 'rounded-br-2xl' : 'rounded-b-2xl'} border-2 border-gray-200 p-2`}
      >
        <LibraryList prompts={libraryPrompts} />
      </div>
    </>
  );
};

export default ImportLibraryView;
